import { TypeM3PrdGrp } from "../Maestro/M3PrdGrp.type";
import { M3RegService } from "./m3-reg-service";
import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { M3PrdLista } from "../Maestro/M3PrdLista.type";
import { M3PrdGeneral } from "../Maestro/M3PrdGeneral.type";
import { CouchConfigLPService } from "../Offline/couch-configlp.service";
import { MathTF } from "../Miscelanea/MathTF.class";
import { M3PrdAdicionales } from "../Maestro/M3PrdAdicionales.type";

export class ServiceLoadListaPrecio {
    private oMathTF = new MathTF();
    private gsidkatios: string;
    private aplPreciosDinamicos: boolean = false;

    constructor(idkatios) {
        this.gsidkatios = idkatios;
        this.GetKatiosM3FromSession();
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetKatiosM3FromSession() {
        let Katios = localStorage.getItem("ConfigKatios" + this.gsidkatios.toUpperCase());
        if (Katios !== undefined && Katios != null) {
            var jKatiosM3 = JSON.parse(Katios);
            if (jKatiosM3 && jKatiosM3.Katios && jKatiosM3.Katios.KatiosM3) {
                let apl = jKatiosM3.Katios.KatiosM3.find(x => x.Llave.toUpperCase() == "APLLPDINAMICOS");
                if (apl && apl.Valor == "1") {
                    this.aplPreciosDinamicos = true;
                }
            }
        }
    }

    ///Asignar lista de precios, segun lista de precios asociado a usuario por cada ujno de  los productos hijos
    public async AsignarListaPrecioM3Pack(ProductoMaestro: TypeM3PrdGrp, oDataUser: any, oPostServiceM3: PostServiceM3) {

        for (const oM3PrdGrpAsociado of ProductoMaestro.M3PrdGrpAsociado) {
            await this.AsignarListaPrecio(oM3PrdGrpAsociado.M3GRP, oDataUser, oPostServiceM3)
        }

        for (const prdGeneral of ProductoMaestro.LoM3PrdGeneral) {
            for (const m3Pack of prdGeneral.M3PACK) {
                await this.AsignarListaPrecio(m3Pack.M3GRP, oDataUser, oPostServiceM3)
            }
        }
        return "";
    }

    ///Asignar lista de precios, segun lista de precios asociado a usuario.
    public async AsignarListaPrecio(ProductoMaestro: TypeM3PrdGrp, oDataUser: any, oPostServiceM3: PostServiceM3) {
        this.GetKatiosM3FromSession();
        if (oDataUser != null && oDataUser.UsuarioSistema.IDLPrecio !== undefined && oDataUser.UsuarioSistema.IDLPrecio != -1) {
            for (var i = 0; i < ProductoMaestro.LoM3PrdGeneral.length; i++) {
                var prdGrl = ProductoMaestro.LoM3PrdGeneral[i];
                let splitPrecio = oDataUser.UsuarioSistema.IDLPrecio.split("-");
                var oListaFinded = prdGrl.LoM3ListaPrecio.find(lPre => lPre.IDLISTA == splitPrecio[0]);
                if (splitPrecio.length > 1) {
                    if (!this.aplPreciosDinamicos) {
                        switch (splitPrecio[1]) {
                            case "LB":
                                oListaFinded.PRECIO = oListaFinded.LB;
                                break;
                            case "LC":
                                oListaFinded.PRECIO = oListaFinded.LC;
                                break;
                            case "LD":
                                oListaFinded.PRECIO = oListaFinded.LD;
                                break;
                            default:
                        }
                    }
                    else {
                        try {
                            let oCouchConfigLPService = new CouchConfigLPService();
                            let listaCouch = await oCouchConfigLPService.get(splitPrecio[0])
                            let jConfigLP = JSON.parse(listaCouch.JConfiguracion);
                            if (jConfigLP && jConfigLP.Factores && jConfigLP.Factores.length > 0) {
                                let factor = parseFloat(jConfigLP.Factores.find(x => x.Nombre == splitPrecio[1]).Factor);
                                oListaFinded.PRECIO = this.oMathTF.round(oListaFinded.PRECIO * factor, 2);
                                oListaFinded.M3Presentaciones.forEach(presentacion => {
                                    presentacion.VALOR = this.oMathTF.round(presentacion.VALOR * factor, 2)
                                });
                            }
                        }
                        catch (Ex) {
                            console.log("error en asignarlistaprecio: " + Ex.message + " - " + splitPrecio[0])
                        }
                    }
                }

                if (oListaFinded !== undefined) {
                    prdGrl.LoM3PrdLista = oListaFinded;
                } else {
                    await this.ValidarDataFromInventario(prdGrl, oDataUser, oPostServiceM3);
                }
            }
            let oM3PrdAdicionales = new M3PrdAdicionales();
            oM3PrdAdicionales.ATRIBUTO = "LISTAPRECIO";
            oM3PrdAdicionales.VALOR = oDataUser.UsuarioSistema.IDLPrecio;
            ProductoMaestro.LoM3PrdAdicionales.push(oM3PrdAdicionales);
        }
        if (ProductoMaestro) {
            await this.AsignarListaPrecioM3Pack(ProductoMaestro, oDataUser, oPostServiceM3);
        }
        return "";
    }

    public async AsignarListaPrecioAGeneral(prdGrl: M3PrdGeneral, oDataUser: any, oPostServiceM3: PostServiceM3) {
        if (oDataUser != null && oDataUser.UsuarioSistema.IDLPrecio !== undefined && oDataUser.UsuarioSistema.IDLPrecio != -1) {
            var oListaFinded = prdGrl.LoM3ListaPrecio.find(lPre => lPre.IDLISTA == oDataUser.UsuarioSistema.IDLPrecio);
            if (oListaFinded !== undefined) {
                prdGrl.LoM3PrdLista = oListaFinded;
            } else {
                await this.ValidarDataFromInventario(prdGrl, oDataUser, oPostServiceM3);
            }
        }
        return "";
    }


    public async ValidarDataFromInventario(prdGrl: M3PrdGeneral, oDataUser: any, oPostServiceM3: PostServiceM3) {
        var sLista: string = oDataUser.UsuarioSistema.IDLPrecio;
        var oM3RegService: M3RegService = new M3RegService(null, null, null);
        //Validar si es un valor de inventario.
        if (sLista.split('_')[0] == "INV") {
            var jData: any = { "ubicacion": oDataUser.UsuarioSistema.UBICACION, "sku": prdGrl.SKU, "lote": prdGrl.LOTE, "concepto": sLista.split('_')[1] };
            var precio = await oM3RegService.GetConceptoM3SaldosItemUb(oPostServiceM3, this.gsidkatios, jData);
            if (precio && precio != 0) {
                var oM3PrdLista = new M3PrdLista();
                oM3PrdLista.IDLISTA = oDataUser.UsuarioSistema.IDLPrecio;
                oM3PrdLista.LOTE = prdGrl.LOTE;
                oM3PrdLista.PRECIO = precio;
                oM3PrdLista.SKU = prdGrl.SKU;
                prdGrl.LoM3PrdLista = oM3PrdLista;
            }
        }
    }


}